﻿import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { User } from '../_models';
import { isNull } from 'util';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    // getAll() {
    //     return this.http.get<User[]>(environment.dist + '/users');
    // }

    getById(id: number) {
        // return this.http.get<User>(AppConst.dist+'/users/${id}');
    }

    getCurrentUserName() {
        let ret = '';
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (!isNull(currentUser.first_name)) {
            ret += currentUser.first_name;
        }
        if (!isNull(currentUser.last_name)) {
            ret += currentUser.last_name;
        }
        return ret;
    }

    getCurrentUserID() {
        let ret: number = undefined;
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (!isNull(currentUser.uid)) {
            ret = currentUser.uid;
        }        
        return ret;
    }
}